import React from "react";

import Cart from "../../components/Cart";
import { ScrollToTopOnMount } from "../../components/common/ScrollToTopOnMount";
import Footer from "../../components/Footer";

const CartPage = () => {
  return (
    <>
      <ScrollToTopOnMount />
      <Cart />
      <Footer />
    </>
  );
};

export default CartPage;
